export const APP_VERSION = "v0.9.0 Beta";
export const APP_STAGE = "Beta";
export const APP_VERSION_NOTE =
  "You are using the Beta version of We-Help. Some features may change as we improve the platform.";